export default class ServiceUtils {
  static buildSearchParams(params?: string): string {
    return params ? `search=${params}` : '';
  }
}
